export enum BackgroundTextureTypes {
  PRIMARY_TEAR = "PRIMARY_TEAR",
  SECONDARY_TEAR = "SECONDARY_TEAR",
}
